<template>
  <el-container class="h-full">
    <el-header height="30px">上月上报情况</el-header>
    <el-main class="overflow-x-auto">
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="名称"
          width="180"
        />
        <el-table-column
          prop="status"
          label="上报状态"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1">已上报</el-tag>
            <el-tag v-else type="info">未上报</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="date"
          label="上报时间"
          width="180"
        />
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ReportStatus',
  data() {
    return {
      tableData: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      axios.get('/dashboard/report_status').then(res => {
        if (res.data.status === 1) {
          this.tableData = res.data.list
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .arrow_box {
    position: relative;
    background: #555;
    border: 2px solid #000000;
  }

  .arrow_box:after, .arrow_box:before {
    right: 100%;
    top: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:after {
    border-color: rgba(85, 85, 85, 0);
    border-right-color: #555;
    border-width: 10px;
    margin-top: -10px;
  }

  .arrow_box:before {
    border-color: rgba(0, 0, 0, 0);
    border-right-color: #000000;
    border-width: 13px;
    margin-top: -13px;
  }
}

</style>
